module.exports = __webpack_public_path__ + "static/about-20b3b5d322d607c665aaa786fc2160bd.gif";